<template functional>
    <div class="float-right">
        <hemocir-button
            :title="props.okTitle"
            variant="primary"
            class="mr-3 ok-button"
            @click="props.okFunction"
        />
        <hemocir-button
            :title="props.cancelTitle"
            variant="secondary-bootstrap"
            class="cance-button"
            @click="props.cancelFunction"
        />
    </div>
</template>

<script>
    export default {
        name: "CreateCancelButtons",
        props: {
            okTitle: {
                type: String,
                required: true,
            },
            okFunction: {
                type: Function,
                required: true,
            },
            cancelTitle: {
                type: String,
                required: true,
            },
            cancelFunction: {
                type: Function,
                required: true,
            }
        },
    };
</script>

<style scoped>

</style>